import * as React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useRef, useReducer } from 'react';
import { useDispatch } from 'react-redux';
import postParentLead from '@actions/cbseClass';
import { LEADGEN_K12_REGISTERED } from '@constants/segment';
import { segment } from '@actions/analytics';
import { sendEvents } from '@events/sendAnalytics';
import { breakpoints } from '@styles/index';
import pushRoute from '@utils/pushRoute';
import LeadGenCover from './LeadGenCover';
import Footer from './Footer';
import AboutUnacademy from './AboutUnacademy';
import SuccessFul from './SuccessFul';
import reducer from './reducer';
import BookAClass from './Class';
import BottomSheet from '../BookAClass/BottomSheet';
import ClassBooked from './ClassBooked';

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  column-gap: 16px;
  padding-top: 72px;
  width: 1136px;
  margin: auto;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    width: 728px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    padding-top: 56px;
    display: block;
    column-gap: 0;
    margin-top: 0;
  }
`;

const LeadGen = ({ apiResponse, onlyForm }) => {
  const {
    heroForm,
    features,
    featuresBg,
    stats,
    heroContent,
    success
  } = apiResponse;
  const scrollRef = useRef();
  const [state, dispatch] = useReducer(reducer, {
    name: '',
    email: '',
    phoneNumber: '',
    goal_uid: '',
    selectedClass: '',
    errors: {},
    form: 'BOOK_FORM',
    open: false
  });
  const dispatchFn = useDispatch();
  const { form, open } = state;
  const handleSourceLogin = (response) => {
    if (response.error?.error_code === 'E132') {
      dispatch({
        type: 'SET_ERRORS',
        payload: { email: response.error.message }
      });
      dispatch({ type: 'SET_FORM', payload: 'BOOK_FORM' });
      return;
    }
    if (response.error?.error_code) return;
    dispatchFn(
      postParentLead({ name: state.name, goal_uid: state.goal_uid })
    ).then((res) => {
      const { name, email, phoneNumber, goal_uid, selectedClass } = state;
      const data = {
        name,
        email,
        phoneNumber,
        goal_uid,
        class: selectedClass
      };
      if (res.type === 'PARENT_LEAD_SUCCESS') {
        segment.track(LEADGEN_K12_REGISTERED, data);
        sendEvents(LEADGEN_K12_REGISTERED, data);
      }
      if (['8th', '10th'].includes(selectedClass))
        return pushRoute(
          `/cbse-class-6-12/book-a-class/?goalUid=${goal_uid}`,
          `/cbse-class-6-12/book-a-class/?goalUid=${goal_uid}`
        );
      dispatch({ type: 'SET_FORM', payload: 'SUCCESSFUL' });
    });
  };
  React.useEffect(() => {
    sessionStorage.clear('bookedClass');
  }, []);
  return (
    <Container>
      <LeadGenCover scrollRef={scrollRef} heroContent={heroContent} form={form}>
        {form === 'SUCCESSFUL' ? (
          <SuccessFul success={success} type="leadGen" />
        ) : (
          <BookAClass
            handleSourceLogin={handleSourceLogin}
            state={state}
            dispatch={dispatch}
            heroForm={heroForm}
          />
        )}
      </LeadGenCover>
      {form === 'SUCCESSFUL' || onlyForm ? null : (
        <>
          <AboutUnacademy features={features} featuresBg={featuresBg} />
          <Footer scrollRef={scrollRef} stats={stats} />
        </>
      )}
      {form === 'CLASS_BOOKED' ? (
        <BottomSheet open={open}>
          <ClassBooked
            phoneNumber={state.phoneNumber}
            handleClick={() => {
              dispatch({ type: 'TOGGLE_BOOKED_CLASS', payload: false });
            }}
          />
        </BottomSheet>
      ) : null}
    </Container>
  );
};

LeadGen.propTypes = {
  apiResponse: PropTypes.objectOf(PropTypes.any).isRequired,
  onlyForm: PropTypes.bool
};
LeadGen.defaultProps = {
  onlyForm: false
};

export default LeadGen;
